import { z } from 'zod';

import { FeeId, PaymentDueId } from '../BrandedIds';
import { InvestorRemittanceSplit } from '../loan/InvestorRemittanceSplit';
import { zodTemporalPlainDate } from '../Temporal';
import { BaseLoanEvent } from './BaseLoanEvent';
import { FeeType } from './CreateChargeEvent';

const FeeUpdate = z.object({
  feeId: FeeId,
  isDeferred: z.boolean(),
  investorRemittanceSplit: InvestorRemittanceSplit.optional(),
  chargeDate: zodTemporalPlainDate.optional(),
  feeType: FeeType.optional(),
  feeName: z.string().optional().nullable(),
  paymentDueId: PaymentDueId.optional().nullable(),
});

export const UpdateFeesEvent = BaseLoanEvent.extend({
  type: z.literal('updateFees'),
  feeUpdates: z.array(FeeUpdate).min(1),
  comment: z.string().optional(),
});
export type UpdateFeesEvent = z.infer<typeof UpdateFeesEvent>;
